import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="text-8xl font-extrabold text-orange-600 mb-4">404</div>
        <h1 className="text-2xl font-bold text-slate-900 mb-3">Page introuvable</h1>
        <p className="text-slate-500 mb-8">La page que vous cherchez n'existe pas ou a été déplacée.</p>
        <Link to="/" className="bg-orange-600 hover:bg-orange-700 text-white font-bold px-8 py-3.5 rounded-lg transition-colors inline-block">Retour à l'accueil</Link>
      </div>
    </div>
  );
}
